import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl/dist';
import { Link } from 'react-router-dom';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';

import { showModal } from '../../actions/common/actionCreators';
import { ticketCategoriesSelector, ticketCategoriesLoadedSelector } from '../../selectors/ticketMgmtSelectors';
import { getTicketCategories, updateCategories } from '../../actions/ticketMgmtPortal/ticketMgmtPortalActionCreators';
import { configs } from '../../constants/configs/configs';
import { CATEGORY_FORM_NAMES, CATEGORY_FORM_FIELDS, ENTITY_TYPES } from './forms/ticketFormConfigs';
import { ticketMgmtModalTypes } from '../../constants/ticketMgmt/modals/ticketMgmtModalTypes';

const TicketCategories = (props) => {
    const {
        ticketCategories,
        updateCategories,
        getTicketCategories,
        loaded,
        showModal
    } = props;

    useEffect(() => {
        if(!loaded) getTicketCategories();
    }, [loaded]);

    const handleAddNewCategory = () => {
        showModal({
            modalType: ticketMgmtModalTypes.TICKET_TYPE_MODAL,
            modalData: {
                className: 'ticket_management',
                headerText: 'ticket_management.add_new_category',
                initialFormValues: { [CATEGORY_FORM_NAMES.NEW_CATEGORY]: '', [CATEGORY_FORM_NAMES.SPANISH_NAME]:'' },
                formFields: CATEGORY_FORM_FIELDS,
                entity: ENTITY_TYPES.CATEGORY,
                onSaveHandler: ({ newCategory, spanishName  }) => updateCategories({
                    category: newCategory,
                    type: newCategory,
                    description: newCategory,
                    categoryEs: spanishName,
                    typeEs: spanishName

                })
            }
        });
    };
    
    return (
        <div id="ticketCategories">
            <div className="gi-panel">
                <div className='ticket-categories__header'>
                    <h3>
                        <FormattedMessage id="ticket_management.ticket_categories"/>
                    </h3>
                    <Button
                        id='addNewTicketCategory'
                        className='usa-button gi-button gi-button__primary gi-button--small ticket__add-category margin-top-1'
                        onClick={handleAddNewCategory}
                    >
                        <FormattedMessage id="ticket_management.add_new_category"/>
                    </Button>
                </div>

                <ul className='ticket-categories__list'>
                    {Object.keys(ticketCategories).map((category, index) => (
                        <li key={index}>
                            {ticketCategories[category] ? 
                                <Link to={`${configs.routes.TICKET_MGMT_TYPES}/${category}/${ticketCategories[category]}`}>{category}</Link> : 
                                <Link to={`${configs.routes.TICKET_MGMT_TYPES}/${category}`}>{category}</Link>}
                            {ticketCategories[category] ? 
                                '- ('+ ticketCategories[category]+ ')': ''}
                        </li>
                    ))}
                </ul>
            </div>

        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    loaded: ticketCategoriesLoadedSelector,
    ticketCategories: ticketCategoriesSelector
});

export default connect(mapStateToProps, { showModal, updateCategories, getTicketCategories })(TicketCategories);